import { IApiCoverageAccount, IApiCoverageAccountCreate } from '@cbridge-packages/api-coverage';
import { ICoverageAccount, ICoverageAccountForm } from './coverageAccount.interface';

export namespace CoverageAccountTranslator {
  // Accounts arrive embedded in GET /external-reporting/reports; the owning reportId comes
  // from the parent report, not the account DTO. The embedded id is documented as a string
  // (unlike the integer create response) — normalize to number.
  export function fromApi(account: IApiCoverageAccount, reportId: ICoverageAccount['reportId']): ICoverageAccount {
    return {
      accountId: Number(account.id),
      reportId,
      serverId: account.serverId,
      name: account.name,
      externalId: account.externalId,
      invertSide: account.invertSide,
    };
  }

  // reportId + serverId travel in the URL path, so the body carries only mutable fields.
  export function toApi(form: ICoverageAccountForm): IApiCoverageAccountCreate {
    return {
      name: form.name,
      externalId: form.externalId,
      invertSide: form.invertSide,
    };
  }
}
